import { h } from "omi";

import { IconProps } from "@/components";

export function PinActiveIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 18 19">
      <path
        d="M5.98065 12.6344 1.2666 17.3485M8.74539 5.15567 7.44465 6.45641c-.10611.10611-.15916.15916-.2196.20131a.833035.833035 0 0 1-.17241.09227c-.0686.02691-.14217.04163-.28931.07106l-3.05372.61074c-.79359.15872-1.19038.23808-1.37602.44729-.16172.18225-.23557.42616-.20211.66752.03841.27704.32454.56318.89681 1.13544l5.90478 5.90476c.57226.5723.85839.8584 1.13543.8968.2414.0335.4853-.0404.6675-.2021.2092-.1856.2886-.5824.4473-1.376l.6108-3.0537c.0294-.1472.0441-.2207.071-.2893a.833455.833455 0 0 1 .0923-.1724c.0421-.0605.0952-.1135.2013-.2196l1.3007-1.30078c.0679-.06784.1018-.10176.1391-.13137a.833038.833038 0 0 1 .1049-.07104c.0413-.02362.0854-.04252.1736-.08031l2.0786-.89084c.6065-.25989.9097-.38984 1.0474-.59983.1204-.18363.1635-.40738.1199-.6226-.0499-.24612-.2831-.47938-.7497-.94591l-4.2859-4.28594c-.4665-.46652-.6998-.69979-.9459-.74968-.2152-.04363-.439-.00054-.6226.1199-.21.13774-.34.44094-.59985 1.04736L9.0281 4.73809c-.03779.08818-.05668.13227-.0803.17362a.833256.833256 0 0 1-.07104.10492c-.02962.03729-.06354.07121-.13137.13904Z"
        stroke="#1B1918"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
